import { defineComponent as _defineComponent } from 'vue'
import { computed, defineAsyncComponent, inject } from 'vue';
    import { IStore } from '../Store';
    import { SvcAliases } from '../SvcAliases';
    import crossIcon from '../assets/cross_icon.svg';

    interface ModelDef {
        component: any;
        title?: string;
        subtitle?: string;
        footerComponent?: any;
    }

    
export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

    const store = inject(SvcAliases.Store) as IStore;

    const modals: { [key :string]: ModelDef } = {
        SignUp: { title: "Recevez votre projet", subtitle: "En m’inscrivant gratuitement je reçois par mail : mon projet 3D ainsi qu’un devis.", component: defineAsyncComponent(() => import("./forms/SignupForm.vue")) },
        Login: { title: "Connexion", component: defineAsyncComponent(() => import("./forms/LoginForm.vue")) },
        ForgotPass: { title: "Réinitialiser mon mot de passe", component: defineAsyncComponent(() => import("./forms/ForgotPassForm.vue")) },
        Save: { title: "Enregistrement", subtitle: "Comment souhaitez-vous l'enregistrer ?", component: defineAsyncComponent(() => import("./controls/SavePopup.vue")) },
        Desktop: { component: defineAsyncComponent(() => import("./components/Desktop.vue")), footerComponent: defineAsyncComponent(() => import("./components/AdvancedMode.vue")) },
        NONE: { component: undefined }
    }

    const title = computed(() => (modals[store.currentModal] && modals[store.currentModal].title ? modals[store.currentModal].title : "" ));
    const subtitle = computed(() => (modals[store.currentModal] && modals[store.currentModal].subtitle ? modals[store.currentModal].subtitle : "" ));
    const component = computed(() => (modals[store.currentModal] ? modals[store.currentModal].component : undefined ));
    const footerComponent = computed(() => (modals[store.currentModal] ? modals[store.currentModal].footerComponent : undefined ));


const __returned__ = { store, modals, title, subtitle, component, footerComponent, crossIcon }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})